export default __webpack_public_path__ + "static/media/training.4c4006ec.svg";